import { getHelpRoute } from "../config/helpKnowledgeBuilder";

/**
 * Parses assistant message text into plain text and navigable link segments.
 * Supports: [[Label|/path]]
 */
export function parseHelpMessageSegments(content) {
  if (!content) return [];

  const segments = [];
  const bracketRe = /\[\[([^|\]]+)\|(\/[a-zA-Z0-9/_-]+)\]\]/g;
  let cursor = 0;
  let match;

  while ((match = bracketRe.exec(content)) !== null) {
    if (match.index > cursor) {
      segments.push({ type: "text", value: content.slice(cursor, match.index) });
    }
    const path = match[2].trim();
    const route = getHelpRoute(path);
    segments.push({
      type: "link",
      label: match[1].trim() || route?.label || path,
      path,
    });
    cursor = match.index + match[0].length;
  }

  if (cursor < content.length) {
    segments.push({ type: "text", value: content.slice(cursor) });
  }

  return segments.length > 0 ? segments : [{ type: "text", value: content }];
}
